<template>
  <div>
    <b-modal v-model="showModal" centered header-class="custom-modal-header" footer-class="custom-modal-footer">
      <template #modal-header>
        <p class="text-header">Import Keyword Tag</p>
      </template>
      <div class="text-center">
        <div class="mt-2">
          <InputTextArea
            v-if="refreshAfterPaste"
            class="mb-2"
            type="text"
            textFloat=""
            placeholder="Import Keyword Tag"
            name="keyword"
            rows="10"
            @onPaste="onPasteKeyword"
            @onKeyup="onKeyupKeyword"
            v-model="keyword"
            :isValidate="$v.keyword.$error"
            :v="$v.keyword"
          />
        </div>
        <div class="px-2 py-2 mb-2 keyword-card" v-if="keywordTags.length > 0">
          <div class="d-flex flex-wrap">
            <div
              v-for="(keyword, kindex) in keywordTags"
              :key="kindex"
              class="d-flex keyword-box p-1 mr-1 mb-1"
            >
              <div class="m-auto text-keyword px-2">
                {{ keyword }}
              </div>
              <div class="ml-2 mr-1 pointer">
                <font-awesome-icon
                  class="my-auto"
                  icon="times"
                  @click="onDeleteKeyword(kindex)"
                />
              </div>
            </div>
          </div>
        </div>
        
        <!-- <div class="d-flex justify-content-between">
          <b-button
            :disabled="isDisable"
            @click="hide"
            class="btn-details-set btn-cancel"
            >CANCEL</b-button
          >

          <button
            type="button"
            @click="checkForm()"
            :disabled="isDisable"
            class="btn btn-main btn-details-set ml-md-2 text-uppercase"
          >
            Confirm
          </button>
        </div> -->
      </div>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-between">
          <button
            class="cancel-button"
            :disabled="isDisable"
            @click="hide"
          >
            Cancel
          </button>
          <button class="save-button" type="button" @click="checkForm()" :disabled="isDisable">
            Confirm
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import InputTextArea from "@/components/inputs/InputTextArea";
import { required } from "vuelidate/lib/validators";
export default {
  components: {
    InputTextArea,
  },
  props: {
    keywordList: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      showModal: false,
      keyword: "",
      isDisable: false,
      refreshAfterPaste: true,
      keywordTags: [],
    };
  },
  validations: {
    keyword: { required },
  },

  methods: {
    onDeleteKeyword(index) {
      this.keywordTags.splice(index, 1);
      this.refreshAfterPaste = false;
      this.$nextTick(() => {
        this.refreshAfterPaste = true;
        this.keyword = "";
        this.keywordTags.forEach((element) => {
          this.keyword = this.keyword + element + ", ";
        });
      });
    },
    onKeyupKeyword(event) {
      var keywordListTemp = this.keyword.split(",");
      keywordListTemp = keywordListTemp.map((el) => el.trimLeft());
      keywordListTemp = keywordListTemp.filter((el) => el !== "");
      this.keywordTags = keywordListTemp;
    },
    onPasteKeyword(event) {
      var keyword = event.clipboardData.getData("Text");
      const value = keyword.replace(/\r\n|\r|\n/g, ", ");

      var keywordListTemp = value.split(",");
      keywordListTemp = keywordListTemp.map((el) => el.trimLeft());
      keywordListTemp = keywordListTemp.filter((el) => el !== "");
      keywordListTemp.forEach((temp) => {
        if (!this.keywordTags.includes(temp)) {
          this.keywordTags.push(temp);
        }
      });

      //set keyword
      this.refreshAfterPaste = false;
      this.$nextTick(() => {
        this.refreshAfterPaste = true;
        this.keyword = "";
        this.keywordTags.forEach((element) => {
          this.keyword = this.keyword + element + ", ";
        });
      });

      //get keyword
    },
    setKeywordPreview() {
      var keywordListTemp = this.keyword.split(",");
      keywordListTemp = keywordListTemp.map((el) => el.trimLeft());
      keywordListTemp = keywordListTemp.filter((el) => el !== "");
      keywordListTemp.forEach((temp) => {
        if (!this.keywordTags.includes(temp)) {
          this.keywordTags.push(temp);
        }
      });
    },
    checkForm() {
      this.$v.$touch();
      if (this.$v.$error) {
        return;
      }
      this.submit();
    },
    submit() {
      this.$emit("onImportKeyword", this.keywordTags);
      this.hide();
    },
    show() {
      this.showModal = true;
      this.refreshAfterPaste = false;
      this.$nextTick(() => {
        this.refreshAfterPaste = true;
        this.keyword = "";
        this.keywordList.forEach((element) => {
          this.keyword = this.keyword + element + ", ";
        });
        this.keywordTags = JSON.parse(JSON.stringify(this.keywordList));
        this.$v.$reset();
      });
    },
    hide() {
      this.showModal = false;
    },
  },
};
</script>

<style scoped>
.keyword-card {
  border-left: 1px solid #bcbcbc;
  border-right: 1px solid #bcbcbc;
  border-bottom: 1px solid #bcbcbc;
  border-top: 1px solid #bcbcbc;
  height: 230px;
  overflow: auto;
  border-radius: 6px;
}

.keyword-box {
  background-color: #e2dff3;
  color: #7b7b7b !important;
  font-size: 14px;
  white-space: break-spaces;
  font-weight: 400 !important;
  border-radius: 25px;
}
.keyword-div {
  max-height: 150px;
  overflow-y: auto;
}
.text-keyword {
  word-break: break-word;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.modal-body {
  margin: auto;
  text-align: center;
}
</style>
